export default "__VITE_ASSET__B5Cfxwk6__"